// extracted by mini-css-extract-plugin
export var button = "style-module--button--RJ0Ya";
export var buttonDisable = "style-module--buttonDisable--eFi0o";
export var buttons = "style-module--buttons--1QeE9";
export var floorMapSlider = "style-module--floorMapSlider--xAat-";
export var swiper = "style-module--swiper--bMZOO";